import { ButtonBase } from '@mui/material';
import Carousel from 'components/carousel';
import { useAccountState } from 'contexts/account/account-context';
import { useGet } from 'hooks/use-get';
import { getMarketImages } from 'views/overview/api/image-heading';
import { ImageHeading } from 'views/overview/types/image-heading.type';

const baseUrl = `${import.meta.env.VITE_REST_API_URL}`;

const ImageBox: React.FC<{ image: ImageHeading }> = ({ image }) => {
  return (
    <ButtonBase
      onClick={() => {
        if (image.linkedUrl) window.open(image.linkedUrl, '_blank');
      }}
      sx={{
        flexShrink: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: `linear-gradient(to bottom, rgba(255, 255, 255, 0) 50%, #00000033 75%, #00000099 100%);`,
        },
      }}>
      <img
        style={{
          objectFit: 'cover',
          width: '100%',
          height: '100%',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        }}
        alt={image.title}
        src={`${baseUrl}${image.imageUrl}`}
      />
    </ButtonBase>
  );
};

const LandingCarousel = () => {
  const { account } = useAccountState();

  const { data: carouselImages } = useGet(['getMarketImages', account.company?.marketId], ({ queryKey }) =>
    getMarketImages(Number(queryKey[1]))
  );

  return (
    <Carousel
      children={carouselImages?.map((image, idx) => (
        <ImageBox key={idx} image={image} />
      ))}
    />
  );
};

export default LandingCarousel;
